import { render } from "./ParticipationThumbnail.vue?vue&type=template&id=063e9300&ts=true"
import script from "./ParticipationThumbnail.vue?vue&type=script&lang=ts"
export * from "./ParticipationThumbnail.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__